import React, { FC, ReactNode } from 'react'
import { graphql } from "gatsby"
import { renderRichText } from "gatsby-source-contentful/rich-text"

import { ContentBlockquoteFragmentFragment } from "@graphqlTypes"

import { textOptions } from '../../Content.utils'

import AvatarPlusInfo from '@components/AvatarPlusInfo/AvatarPlusInfo'
import AvatarWithName from "@components/AvatarWithName/AvatarWithName"
import { AVATAR_SIZES } from '@components/Avatar/Avatar'

import {
  ContentBlockquoteDIV,
} from "./ContentBlockquote.styles"
import ContentBreakout from '../ContentBreakout/ContentBreakout'

export enum CONTENT_BLOCKQUOTE_VARIANTS {
  S = "S",
  L = "L"
}

const BlockquoteWithAttribution: FC<ContentBlockquoteFragmentFragment & { children?: ReactNode }> = ({
  attributionAvatar,
  attributionName,
  attributionRole,
  children,
  quote,
  variant,
}) => {
  const quoteText = quote ? renderRichText(quote, textOptions) : ""
  return (
    <>
      <blockquote className="color--text-dark">
        {quoteText || children}
      </blockquote>

      {(attributionAvatar || attributionName) &&
        (variant === AVATAR_SIZES.L ? (
          <AvatarPlusInfo
            bio={attributionRole || ""}
            image={attributionAvatar}
            name={attributionName || ""}
          />
        ) : (
          <AvatarWithName
            bio={attributionRole || ""}
            image={attributionAvatar}
            name={attributionName || ""}
          />
        )
        )}
    </>
  )
}

const ContentBlockquote: FC<ContentBlockquoteFragmentFragment & { children?: ReactNode }> = (props) =>
  props.variant === CONTENT_BLOCKQUOTE_VARIANTS.L ? (
    <ContentBreakout>
      <div className="container">
        <div className="grid">
          <div className="column column--2-12-M">
            <ContentBlockquoteDIV className="ContentBlockquote variant--L">
              <BlockquoteWithAttribution {...props} />
            </ContentBlockquoteDIV>
          </div>
        </div>
      </div>
    </ContentBreakout>
  ) : (
    <ContentBlockquoteDIV className="ContentBlockquote">
      <BlockquoteWithAttribution {...props} />
    </ContentBlockquoteDIV>
  )

export const BlockQuoteFragment = graphql`
  fragment ContentBlockquoteFragment on ContentfulContentBlockBlockquote {
    contentful_id
    quote {
      raw
    }
    attributionName
    attributionRole
    attributionAvatar {
      title
      imgixImage {
        url
        gatsbyImageData(aspectRatio: 1)
      }
    }
    variant
  }
`

export default ContentBlockquote
